import "../components/accordion/index.bundle";
import "../components/carousel/index.bundle";
import "../components/css-custom-properties/index.bundle";
import "../components/usp/index.bundle";
import "../components/icons/index.bundle";
import "../components/global-header/index.bundle";
import "../components/add-to-basket-modal/index.bundle";
import "../components/purchase-panel/index.bundle";
import "../components/cookie-banner/index.bundle";
